import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#0080c4',
                secondary: '#499e2c',
                error: '#e40028',
            },
        },
    },
});
